export default __webpack_public_path__ + "static/media/hello.38be7d40.PNG";